import React, { useState, useEffect } from "react";

import { t } from "i18next";

import styles from "./PlaylistRedirect.module.css";

interface IPlaylistRedirect {
  cover?: string;
}

export const PlaylistRedirect = ({ cover }: IPlaylistRedirect) => {
  const [time, setTime] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime === 0) {
          clearInterval(interval);
          return prevTime;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(interval); // Clean up the interval
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.bakcground}
        style={{ backgroundImage: cover ?? "" }}
      />
      <span className={styles.typography}>{t("playlist.redirect") + time}</span>
    </div>
  );
};
